import React from 'react'
import { Link } from "react-router-dom";

function PageUnauthorized() {
    return (
        <div class="section position-relative">
            <div className='page-not-found'>
                <img src='/images/403Forbidden.svg' />
                <div class="page">You don't have permission to access this resource</div>
                <Link class="theme-btn-primary" to={'/home'} >Back to Home</Link>
            </div>
        </div>
    )
}

export default PageUnauthorized